import { FeatureKey } from '@gql';
import { IconNames } from './icon';

export const mapFeatureKeyToIconName = (featureKey: FeatureKey): IconNames => {
  switch (featureKey) {
    case FeatureKey.Bar:
    case FeatureKey.BbqGrills:
    case FeatureKey.BreakfastIncluded:
    case FeatureKey.ComplimentaryBeveragePantries:
    case FeatureKey.ContinentalBreakfast:
    case FeatureKey.DiningArea:
    case FeatureKey.DinnerAvailableForAdditionalCost:
    case FeatureKey.DinnerIncludedInRoomRate:
    case FeatureKey.FullBreakfast:
    case FeatureKey.HeavyContinentalBreakfast:
    case FeatureKey.HighChair:
    case FeatureKey.InRoomBreakfastAvailable:
    case FeatureKey.Minibar:
      return IconNames.PLATE_UTENSILS;

    case FeatureKey.AdultsOnly:
    case FeatureKey.CheckInCheckOutOnlinePhone:
    case FeatureKey.WholeHouseBuildingRental:
    case FeatureKey.Weddings:
    case FeatureKey.MeetingsEvents:
      return IconNames.PEOPLE_GROUP;

    case FeatureKey.AdaCompliant:
    case FeatureKey.WheelchairFriendly:
      return IconNames.WHEELCHAIR;

    case FeatureKey.PrivateBathrooms:
      return IconNames.TOILET_PAPER;

    case FeatureKey.AllowsChildren:
      return IconNames.FAMILY;

    case FeatureKey.FirePlaceInRooms:
      return IconNames.FIREPLACE;

    case FeatureKey.AcceptsGiftCard:
      return IconNames.GIFT_CARD;

    case FeatureKey.KingBedsOnsite:
      return IconNames.BED_FRONT;

    case FeatureKey.NonSmoking:
      return IconNames.BAN_SMOKING;

    case FeatureKey.FreeParking:
      return IconNames.CIRCLE_PARKING;

    case FeatureKey.PetFriendly:
      return IconNames.PAW;

    case FeatureKey.Tv:
      return IconNames.TV;

    case FeatureKey.TwoBedsInRoom:
      return IconNames.BED;

    case FeatureKey.FreeWiFi:
      return IconNames.WIFI;

    case FeatureKey.InRoomClimateControl:
    case FeatureKey.PrivateEntrances:
    case FeatureKey.InRoomBreakfast:
    case FeatureKey.StrictDailyCleaningRegimen:
    case FeatureKey.ContactlessCheckIn:
    case FeatureKey.ContactlessCheckOut:
      return IconNames.PUMP_MEDICAL;
    default:
      return IconNames.STAR;
  }
};
